/** Highest count shown exactly; anything above renders as `99+`. */
export const UNREAD_COUNT_DISPLAY_CAP = 99;

/**
 * Badge text for an unread count, or `undefined` when no badge should render.
 *
 * `undefined` in, `undefined` out; `0` also yields no badge. The two are
 * deliberately indistinguishable to the user -- "no badge" beats "badge reads
 * zero", and every other host that shows this count behaves the same way.
 *
 * The `99+` cap diverges from the sibling `UrgentFollowUpsBadge`, which is
 * uncapped. That is an accepted product decision, not a defect to reconcile.
 */
export const formatUnreadCount = (
  count: number | undefined,
): string | undefined => {
  if (count === undefined || !Number.isFinite(count) || count <= 0) {
    return undefined;
  }

  return count > UNREAD_COUNT_DISPLAY_CAP
    ? `${UNREAD_COUNT_DISPLAY_CAP}+`
    : String(count);
};
